import React from 'react';

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import './SortationOption.scss';

type Variant = 'correct' | 'incorrect' | 'solution' | 'default';

const VariantToClassname: Record<Variant, string> = {
  correct: 'sortation-widget-option__internal--correct',
  incorrect: 'sortation-widget-option__internal--incorrect',
  solution: 'sortation-widget-option__internal--solution',
  default: 'sortation-widget-option__internal--default',
};

export type SortationOptionProps = Omit<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  'className' | 'children' | 'ref'
> & {
  innerRef?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>['ref'];
  optionText: string;
  actions?: React.ReactNode;
  dragged?: boolean;
  variant?: Variant;
};

export const SortationOption = ({
  optionText,
  innerRef,
  dragged,
  variant = 'default',
  actions,
  ...props
}: SortationOptionProps) => {
  return (
    <div
      className={classNames(
        'sortation-widget-option',
        { 'sortation-widget-option--dragged': dragged },
        { 'sortation-widget-option--hoverable': variant === 'default' }
      )}
      ref={innerRef}
      {...props}
    >
      <div className={classNames('sortation-widget-option__internal', VariantToClassname[variant])}>
        <FontAwesomeIcon icon={solid('grip-dots-vertical')} className="sortation-widget-option__icon" />
        <div
          className="sortation-widget-option__text uno-w-full"
          dangerouslySetInnerHTML={{ __html: optionText }}
        ></div>
      </div>

      {actions && <div className="sortation-widget-option__actions">{actions}</div>}
    </div>
  );
};
